import { render, staticRenderFns } from "./PanelGroup.vue?vue&type=template&id=7b7232a2&scoped=true"
import script from "./PanelGroup.vue?vue&type=script&lang=js"
export * from "./PanelGroup.vue?vue&type=script&lang=js"
import style0 from "./PanelGroup.vue?vue&type=style&index=0&id=7b7232a2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b7232a2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/private/workspaces/smart-life/smart-life-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b7232a2')) {
      api.createRecord('7b7232a2', component.options)
    } else {
      api.reload('7b7232a2', component.options)
    }
    module.hot.accept("./PanelGroup.vue?vue&type=template&id=7b7232a2&scoped=true", function () {
      api.rerender('7b7232a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/components/PanelGroup.vue"
export default component.exports